import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import * as digitalIdApi from '../api/digitalIdApi';
import * as settings from '../globals/settings';
import {
    catchOpenIdRedirectThunk, clearEverything, doAuthorizeRedirectThunk,
    fakeAuth, fakeAuthDependants, setOpenIdAuthorizeUrl, localAuth
} from '../actions/auth';
import Loading from '../components/loading';
import { createDeviceId, setErrorState } from '../actions/api';

class LoginScreen extends React.Component {

    componentDidMount() {
        // Wait a second before checking for a callback..
        setTimeout(() => this.doCallbackUrlCheck(), 200);
    }

    componentDidUpdate(prevProps, prevState) {
        // If the authorize url is now available, redirect to it!
        if (prevProps.authorizeUrl === null && this.props.authorizeUrl !== null) {
            // Remove existing authorize url and redirect.
            let redirect = this.props.authorizeUrl;
            this.props.dispatch(setOpenIdAuthorizeUrl(null));
            // Create device id on first redirect.
            this.props.dispatch(createDeviceId());
            window.location.href = redirect;
        }
    }

    // Check for url parameters
    // If there is a "code" parameter, assume we are catching the callback from digital Id login
    // If there is an "error" parameter, assume we are catching the callback from digital Id login but there was an error
    // IN ALL OTHER SITUATIONS, CREATE THE AUTHORIZE URL
    // This should trigger componentDidUpdate clause to perform redirect.
    doCallbackUrlCheck() {
        // Checks for a token inserted into the .env
        // This lets us act as a "logged in user" from localhost
        if(settings.USE_MANUAL_TOKEN){
            this.props.dispatch(localAuth(settings.MANUAL_TOKEN))
            return;
        }
        let { code, error } = this.getUrlParams();
        if (error != null) {
            let { errorDescription } = digitalIdApi.parseOpenIdError(this.props.location);
            this.props.dispatch(setErrorState(true, errorDescription, false));
        } else if (code != null) {
            this.props.dispatch(catchOpenIdRedirectThunk(window.location.href));
        } else if (this.props.authorizeUrl === null && settings.DEBUG == "false") {
            this.props.dispatch(doAuthorizeRedirectThunk());
        }
    }

    getUrlParams() {
        let params = queryString.parse(this.props.location.search);
        return { code: params.code, client_id: params.client_id, error: params.error }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.dispatch(doAuthorizeRedirectThunk());
    }

    handleSubmitBypass = (e) => {
        e.preventDefault();
        this.props.dispatch(fakeAuth());
    }

    handleOpenNewHomePage = (e) =>{
        e.preventDefault();
        this.props.dispatch(fakeAuthDependants());
    }

    handleCreateError = (e) => {
        e.preventDefault();
        this.props.dispatch(setErrorState(true, "fake error...", false));
    }

    renderMainContent() {
        if (settings.DEBUG == "true") {
            return (
                <>
                    <div className="row justify-content-center">
                        <div className="container">
                            <div className="row justify-content-center low-padding" style={{paddingBottom: 3, paddingTop: 30}}>
                                <span className="main-title">MyHealthNB</span>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <form onSubmit={this.handleSubmit}>
                            <div className="row justify-content-center">
                                <button type="submit" class="btn btn-primary custom-button">Login</button>
                            </div>
                        </form>
                    </div>
                </>
            );
        } else {
            return null;
        }
    }

    renderBypassButton() {
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleSubmitBypass}>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">REMOVE ME BYPASS!</button>
                        </div>
                    </form>
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderNewHomeScreenButton(){
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleOpenNewHomePage}>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">REMOVE ME NEWHOMESCREEN!</button>
                        </div>
                    </form>
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderErrorButton() {
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleCreateError}>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">REMOVE ME CREATE ERROR!</button>
                        </div>
                    </form>
                </div>
            );
        } else {
            return null;
        }
    }

    // FIXME Remove fake login!!!!
    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } else if (this.props.isLoadingLogin === true) {
            return <Loading />
        } else if (this.props.isLoggedIn === true || this.props.isFakeLoggedIn === true) {
            return <Redirect to="app" />
        }
        return (
            <div className="container vh-100 justify-content-center align-items-center">
                {this.renderMainContent()}
                {this.renderBypassButton()}
                {this.renderErrorButton()}
                {this.renderNewHomeScreenButton()}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
    }
}

const ConnectedLoginScreen = connect(
    mapStateToProps
)(LoginScreen);
export default withRouter(ConnectedLoginScreen);